import { useContext } from 'react';
import LoadingPlaceholder, { LoaderType } from 'shared/components/loading-placeholder';
import AiConversationContext from './context';

const OpeningNarrative = () => {
  const {
    openingNarrative,
  } = useContext(AiConversationContext);
  if (openingNarrative) {
    return (
      <div className='w-100 mt-5'>
        {openingNarrative}
      </div>
    );
  }
  return (
    <LoadingPlaceholder
      loaderType={LoaderType.HALF}
      className='mt-5'
    />
  );
};

export default OpeningNarrative;
